import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";

import Select from "react-select";
import { Dropdown } from "react-bootstrap";
import { Form, FormGroup, Label, Input } from "reactstrap";
import ReactPanZoom from "react-image-pan-zoom-rotate";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import CreatableSelect from "react-select/creatable";
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";

import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
// import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
//** Import Image */
import food1 from "./../../../../images/foods/food1.jpg";
import food2 from "./../../../../images/foods/food2.jpg";
import food4 from "./../../../../images/foods/food4.jpg";
import food9 from "./../../../../images/foods/food9.png";
import food10 from "./../../../../images/foods/food10.jpg";
import food25 from "./../../../../images/foods/food25.jpg";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import Typography from "@material-ui/core/Typography";
import FoodMenuForm from "./FoodMenuForm";
import VariantItemForm from "./VariantItemForm";
import AddOnForm from "./AddOnForm";
import { Accordion } from "@mui/material";
// import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { makeStyles } from "@material-ui/core/styles";
import {
  GetOutletTimingList,
  MenuList,
  saveofMenuAVL,
  saveslotmaster,
  deleteodmenuAVL,
  updateslotmaster,
  getMenuAvailalbitListApi,
  saveoutletDetails,
  getRoleMaster,
  getoutletListMaster,
  addOutletItem,
  UpdateCategoryItem,
  gettstaffListMaster,
  getMenuMasterList,
  saveMainMenuName,
  UpdateMenuName,
  updatePWDstaffDetails,
  saveSubMenuName,
  UpdateSubMenuName,
  submenuCategoryMasterList,
  menuCategoryMasterList,
  CatgorysubList,
  deletecategory, fetchOutletItemCategoryApiReq, getCompanyListMaster
} from "../../../../apiservicescall/api";
import swalMessage from "@sweetalert/with-react";
import swal from "sweetalert";
import Table from "@mui/material/Table";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
// import Stepper from "@material-ui/core/Stepper";
// import Step from "@material-ui/core/Step";
// import StepLabel from "@material-ui/core/Step";
// import StepButton from "@material-ui/core/StepButton";
// import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
import {
  // Table,
  Badge,
  Row,
  Card,
  Col,
  Button,
  Container,
  ListGroup,
  Tab,
} from "react-bootstrap";
import { CardTitle, CardBody } from "reactstrap";
import Multiselect from "multiselect-react-dropdown";
import SelectSearch, { fuzzySearch } from "react-select-search";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: "#00b53b",
    // backgroundColor: "red"
  },
  rootExpanded: {
    flexGrow: 1,
    width: "100%",
    // backgroundColor: "#00b53b"
    // backgroundColor: "blue"
  },
}));

const MenuSubMenuCategory = (props) => {
  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];
  const [admintomanger, setAdmintomanger] = useState(
    JSON.parse(localStorage.getItem("admintomanger"))
  );

  const admintomangerjson = admintomanger && admintomanger.split("-");
  const adminToMangerOutletName = admintomangerjson && admintomangerjson[0].trim();
  const adminToMangerOutletCode = admintomangerjson && admintomangerjson[1].trim();
  const adminToMangerCompanyCode = admintomangerjson && admintomangerjson[2].trim();

  const listItem = ["Breakfast", "Lunch", "Dinner", "Dosas"];
  const [mappinglist, setMappinglist] = useState(true);
  const [menuFoodItemModal, setMenuFoodItemModal] = useState(false);
  const [subMenuModal, setSubMenuModal] = useState(false);
  const [mainMenuModal, setMainMenuModal] = useState(false);
  const [foodItemTiming, setFoodItemTiming] = useState(false);
  const [mappingupdate, setMappingupdate] = useState(false);
  const [menumodal, setMenumodal] = useState(false);
  const [addupdatesubcategory, setAddupdatesubcategory] = useState(false);
  const [addupdatecategory, setAddupdatecategory] = useState(false);
  const [viewcategory, setViewcategory] = useState(false);
  const [deletepopup, setDeletepopup] = useState(false);

  const [selectedMenuType, setSelectedMenuType] = useState("");
  const [todaymenuPopup, setTodaymenuPopup] = useState(false);
  const [menucategory, setMenucategory] = useState([]);
  const [categoryMaster, setCategoryMaster] = useState([]);
  const [selectedcategoryMaster, setSelectedcategoryMaster] = useState({
    label: "",
    value: "",
  });
  const [selectedcategoryvalue, setSelectedcategoryvalue] = useState();
  const [selectedsubcategoryMaster, setSelectedsubcategoryMaster] = useState({
    label: "",
    value: "",
  });
  const [selectedMenuItem, setSelectedMenuItem] = useState({ label: "", value: "", });
  const [subcategoryMaster, setSubcategoryMaster] = useState([]);
  const [errors, setErrors] = useState({
    itemName: null,
    itemPrice: null,
    itemQuantity: null,
    itemType: null,
    itemFoodImage: null,
    itemDesc: null,
    itemId: null,
  });
  const [formIsValid, setFormIsValid] = useState(false);
  const [addFieldValue, setAddFieldValue] = useState();
  const [popUpPageShow, setPopUpPageShow] = useState(false);

  const [checkeditem, setCheckeditem] = useState(false);

  const [isView, setIsview] = useState(false);
  const [isedit, setIsedit] = useState(false);
  const [tempModalPopupValue, setTempModalPopupValue] = useState();
  const [openImagePopup, setOpenImagePopup] = useState();
  //stepper//
  const [activeStep, setActiveStep] = useState(0);
  /* const steps = getSteps(); */
  const [completed, setCompleted] = useState(new Set());
  const [skipped, setSkipped] = useState(new Set());

  const [category, setCategory] = useState([]);

  const [variant, setVariant] = useState([
    { label: "Size", value: "Size" },
    { label: "Quantity", value: "Quantity" },
    { label: "Rice", value: "Rice" },
  ]);

  const [typeadd, setTypeadd] = useState([
    { label: "Extras", value: "Extras" },
    { label: "Toppings", value: "Toppings" },
    { label: "Scoope", value: "Scoope" },
  ]);

  const [menuMasterList, setMenuMasterList] = useState([]);

  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("userDetails"))
  );

  const [loginDetails, setLoginDetails] = useState(
    JSON.parse(localStorage.getItem("userDetails"))
  );

  const [outletvalue, setOutletvalue] = useState({
    label: "",
    value: "",
  });
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [approvalpopup, setApprovalPopup] = useState(false);
  const [tempstatemaster, setTempstatemaster] = useState({});

  const [menuSubmenuItems, setMenuSubmenuItems] = useState({
    status: "",
    menuId: "",
    menuName: "",
    mainMenuId: "",
    subMenuId: "",
    subMenuName: "",
    selectedMainmenuItem: "",
    selectedSubmenuItem: "",
    itemId: "",
    categoryId: "",
    subCategoryId: "",
    mainMenuId: "",

    selectedMainmenuItemValue: "",
    selectedSubmenuItemValue: "",

    selectedIndividualFoodItem: "",
    selectedIndividualFoodItemName: "",

    startTime: "",
    endTime: "",
    itemDesc: "",
    itemName: "",
    itemPrice: "",
    itemQuantity: "",
    itemType: false,
    itemFoodImage: "",
    itemFoodPath: "",
    varient: "",
    /* itemId: "", */
    status: "",
  });

  const [uomcategory, setUomcategory] = useState([]);

  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const rootClass = expanded ? classes.rootExpanded : classes.root;
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const [selectedOutlet, setSelectedOutlet] = useState(
    JSON.parse(localStorage.getItem("selectedOutlet"))
  );

  const [additemSubmenuMaster, setAdditemSubmenuMaster] = useState([]);
  const [timingslist, setTimingslist] = useState([]);
  const [slotmaster, setSlotmaster] = useState([]);
  const [menuAvailablityMaster, setMenuAvailablityMaster] = useState([]);
  const [togglemodal, setTogglemodal] = useState(false);

  const [
    menuAvailablityListSaveUpdateDeleteMaster,
    setMenuAvailablityListSaveUpdateDeleteMaster,
  ] = useState([
    {
      dayId: "1",
      dayName: "Monday",
      dayStatus: "true",
      // slotId: []
    },
    {
      dayId: "2",
      dayName: "Tuesday",
      dayStatus: "true",
      // slotId: []
    },
    {
      dayId: "3",
      dayName: "Wednesday",
      dayStatus: "true",
      // slotId: []
    },
    {
      dayId: "4",
      dayName: "Thursday",
      dayStatus: "true",
      // slotId: []
    },
    {
      dayId: "5",
      dayName: "Friday",
      dayStatus: "true",
      // slotId: []
    },
    {
      dayId: "6",
      dayName: "Saturday",
      dayStatus: "true",
      // slotId: []
    },
    {
      dayId: "7",
      dayName: "Sunday",
      dayStatus: "true",
      // slotId: []
    },
  ]);

  const [dropdownMaster, setDropdownMaster] = useState([
    { label: "All Day", value: "1" },
    { label: "Day Slot", value: "2" },
    // { label: "Week Days Only", value: "3" },
    // { label: "Week End Only", value: "4" }
  ]);

  const [dropdownMasterDay, setDropdownMasterDay] = useState([
    { label: "Monday", value: "1" },
    { label: "Tuesday", value: "2" },
    { label: "Wednesday", value: "3" },
    { label: "Thursday", value: "4" },
    { label: "Friday", value: "5" },
    { label: "Saturday", value: "6" },
    { label: "Sunday", value: "7" },
  ]);

  const [menu, setMenu] = useState([
    { label: "Breakfast", value: "Breakfast" },
    { label: "Lunch", value: "Lunch +" },
  ]);

  const [submenu, setSubmenu] = useState([
    { label: "Dosa varieties", value: "Dosa varieties" },
    { label: "Idly varieties", value: "Idly varieties" },
  ]);





  const [menufetchitem, setMenufetchitem] = useState([
    {
      outletCode: adminToMangerOutletCode || userDetails?.outletCode,
      itemId: "",
      itemName: "",
      itemPrice: "",
      itemQuantity: "",
      itemDesc: "",
      itemType: "",
      itemFoodImage: "",
      categoryName: "",
      subCategoryName: "",
      mainMenuId: "",
      menuId: "",
      subMenuId: "",
      uom: "",
      compCode: adminToMangerCompanyCode || userDetails?.compCode,
    },
  ]);

  const [categoryitem, setCategoryitem] = useState([
    {
      outletCode: adminToMangerOutletCode || userDetails?.outletCode,
      mainMenuId: "",
      mainMenuName: "",
      status: "",
      menuId: "",
      menuName: "",
      subMenuId: "",
      subMenuName: "",
    },
  ]);

  const [selecteduomMaster, setSelecteduomMaster] = useState({
    label: "",
    value: "",
  });

  const [foodTypeFromOutlet, setFoodTypeFromOutlet] = useState("");

  const [menulistitem, setMenulistitem] = useState([
    {
      compCode: "",
      itemDesc: "",
      itemFoodImage: "",
      itemImagePath: "",
      itemId: "",
      itemName: "",
      itemPrice: "",
      itemTag: "",
      itemQuantity: "",
      itemType: true,
      categoryName: "",
      subCategoryName: "",
      mainMenuName: "",
      subMenuName: "",
      mainMenuId: "",
      subMenuId: "",
      categoryId: "",
      subCategoryId: "",
      outletCode: "",
      uom: "",
      uomName: "",
      status: "",

      varient: [
        {
          varientType: "",
          small: "",
          medium: "",
          large: "",
        },
      ],
    },
  ]);

  const [dropdownslotmaster, setDropdownslotmaster] = useState([]);
  const [dropdownMastervalue, setDropdownMastervalue] = useState({
    label: "", name: ""
  });


  const [companyMaster, setCompanyMaster] = useState([]);
  const [restarantvalue, setRestarantvalue] = useState([{ label: "", value: "", }]);
  const [outletMasterlist, setOutletMasterlist] = useState([]);


  useEffect(() => {
    getMenuMasterListMasterApi();

    let outletCode = adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
    let compCode = adminToMangerCompanyCode || loginDetails?.companyCode;
    let checkItemVegTypefromOutletChe = tempstatemaster && tempstatemaster[0]?.items?.outletFoodType == "veg,nong-veg" ? "veg,nong-veg" : "veg";
    setFoodTypeFromOutlet(checkItemVegTypefromOutletChe);
    setMenulistitem({ itemType: true });
    getoutlettimeList(outletCode);
    // getmenulist(compCode, outletCode);
    getcatsublist(outletCode);
    // getmainCategoryMaster(outletCode);
    getcompanyMasterList();
    setMenufetchitem([]);
  }, []);

  //list api//


  // useCallback
  const getcompanyMasterList = useCallback(async () => {
    let getoutletList = await getCompanyListMaster();
    let getoutletListValue = getoutletList?.data?.data;
    let companyoutmaster = getoutletListValue&& getoutletListValue.map(({ compCode, compName }) => ({
      label: compName,
      value: compCode,
    }));
    setCompanyMaster(companyoutmaster);
    setOutletvalue({
      label: getoutletListValue && getoutletListValue[0]?.compName,
      value: getoutletListValue&& getoutletListValue[0]?.compCode,
    });
    getoutletMasterList( getoutletListValue && getoutletListValue[0]?.compCode);
  }, []);


  const getoutletMasterList = async (companyCode) => {
    let getoutletList = await getoutletListMaster(companyCode);
    let getoutletListValue = getoutletList?.data?.data;
    let companyoutmaster = getoutletListValue
      && getoutletListValue.map(({ outletCode, outletName }) => ({
        label: `${outletCode}-${outletName}`,
        value: outletCode,
      }));
    console.log("companyoutmaster", companyoutmaster);
    setOutletMasterlist(companyoutmaster);
  };

  const getcatsublist = async (outletCode) => {
    let getcategoryList = await CatgorysubList(outletCode);
    let getcategoryListValue = getcategoryList?.data?.data;
    setCategoryitem(getcategoryListValue);
    console.log("getcategoryListValue", getcategoryListValue);
  };

  const getmenulist = async (compCode, outletCode) => {
    let getslotList = await fetchOutletItemCategoryApiReq(compCode, outletCode);
    let getslotListValue = getslotList?.data?.data;
    let outmaster = getslotListValue && getslotListValue.map(
      ({
        itemName, itemId, itemPrice, itemImagePath, categoryName, subCategoryName }) => ({
          label: itemName,
          value: itemId,
        })
    );
    setMenufetchitem(getslotListValue);
    setMenucategory(outmaster);
    // console.log("outmaster", outmaster);
    // console.log("getslotListValue", getslotListValue);
    // console.log("menulist", getslotListValue);
  };

  const getoutlettimeList = async (outletCode) => {
    let getoutletList = await GetOutletTimingList(outletCode);
    let getoutletListValue = getoutletList?.data?.data;
    setTimingslist(getoutletListValue);
    console.log("getoutletListValue", getoutletListValue);
  };

  const getmainCategoryMaster = async (outletCode) => {
    let getslotList = await menuCategoryMasterList(outletCode);
    let getslotListValue = getslotList?.data?.data;
    let outmaster =
      getslotListValue &&
      getslotListValue.map(({ menuName, menuId }) => ({
        label: menuName,
        value: menuId,
      }));
    setCategoryMaster(outmaster);
  };

  const getsubcategoryMaster = async (mainMenuId) => {
    let outletCode = adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
    let compCode = adminToMangerCompanyCode || loginDetails?.companyCode;

    let getslotList = await submenuCategoryMasterList(outletCode, mainMenuId);
    let getslotListValue = getslotList?.data?.data;

    let outmaster =
      getslotListValue &&
      getslotListValue.map(({ subMenuName, subMenuId }) => ({
        label: subMenuName,
        value: subMenuId,
      }));
    setSubcategoryMaster(outmaster);
    // console.log("outmaster", outmaster);
    // console.log("getslotListValue", getslotListValue);
  };

  const onAddUpdateUserModalClose = () => {
    setPopUpPageShow(!popUpPageShow);
  };

  const getMenuMasterListMasterApi = async () => {
    menumasterlabelvalue();

    setMenuSubmenuItems({
      menuId: menuSubmenuItems?.menuId,
      menuName: menuSubmenuItems?.menuName,
      selectedSubmenuItem: menuSubmenuItems?.selectedSubmenuItem,
      selectedSubmenuItemValue: menuSubmenuItems?.selectedSubmenuItemValue,
      subMenuId: menuSubmenuItems?.subMenuId,
      selectedMainmenuItem: menuSubmenuItems?.selectedMainmenuItem,
      selectedMainmenuItemValue: menuSubmenuItems?.menuId,
    });
  };

  const menumasterlabelvalue = () => {
    let outmaster =
      menuMasterList &&
      menuMasterList.map(({ menuId, menuName }) => ({
        label: menuName,
        value: menuId,
      }));
    setCategory(outmaster);
  };

  const dropdownHandling = async (type, event) => {
    // if (event?.value == "2") {
    //   setDropdownMasterDay([])
    // }
    setDropdownMastervalue(event);
    console.log("dropdownMastervalue", dropdownMastervalue);
    // const [dropdownMastervalue, ] = useState({ label: "", name: "" });
  };

  const onToggleClose = () => {
    setTogglemodal(!togglemodal);
  };

  const itemtoggle = (items) => {
    // 
    // console.log("items", items)

    getsubcategoryMaster(items?.categoryId);

    setMenulistitem({
      itemDesc: items?.itemDesc,
      itemFoodImage: "",
      itemImagePath: items?.itemImagePath,
      uom: items?.uom,
      itemId: items?.itemId || "",
      menuId: items?.itemId,
      itemName: items?.itemName,
      itemPrice: items?.itemPrice,
      itemQuantity: items?.itemQuantity,
      menuName: items?.mainMenuName,
      mainMenuName: items.categoryName,
      subMenuName: items?.subCategoryName,
      mainMenuId: items?.categoryId,
      subMenuId: items?.subCategoryId,

      itemType: items?.itemType === "veg" ? true : false,
      outletCode: adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode,
      status: "A",
    });
    let tempstatemaster = {};

    setSelectedcategoryMaster({
      label: items?.categoryName,
      value: items?.categoryId
    });
    setSelectedsubcategoryMaster({
      label: items?.subCategoryName,
      value: items?.subCategoryId,
    });

    setSelectedMenuItem({
      label: items?.menuName,
      value: items?.menuId,
    });

    setMappingupdate(true);
    setIsview(true);
    setIsedit(false);
    setFormIsValid(false);
  };

  const viewtoggle = (items) => {

    setMenulistitem({
      itemDesc: items?.itemDesc,
      itemFoodImage: "",
      itemImagePath: items?.itemImagePath,
      uom: items?.uom,
      uomName: items?.uomName,
      itemId: items?.itemId || "",
      itemName: items?.itemName,
      itemPrice: items?.itemPrice,
      itemQuantity: items?.itemQuantity,
      itemTag: items?.itemTag,
      menuName: items?.mainMenuName,

      categoryName: items?.categoryName,
      subCategoryName: items?.subCategoryName,
      categoryId: items?.categoryId,
      subCategoryId: items?.subCategoryId,

      itemType: items?.itemType === "veg" ? true : false,
      outletCode: adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode,
      status: "A",
    });

    setViewcategory(true);
    setIsview(true);
    setIsedit(false);
    setFormIsValid(false);
    /*  setErrors({}); */
  };

  const deletetoggle = (items) => {

    setMenulistitem({
      itemDesc: items?.itemDesc,
      itemFoodImage: "",
      itemImagePath: items?.itemImagePath,
      uom: items?.uom,
      itemId: items?.itemId || "",
      itemName: items?.itemName,
      itemPrice: items?.itemPrice,
      itemQuantity: items?.itemQuantity,
      menuName: items?.mainMenuName,
      categoryName: items?.categoryName,
      subCategoryName: items?.subCategoryName,
      categoryId: items?.categoryId,
      subCategoryId: items?.subCategoryId,

      itemType: items?.itemType === "veg" ? true : false,
      outletCode: adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode,
      status: "A",
    });

    setDeletepopup(true);
    setIsview(true);
    setIsedit(false);
    setFormIsValid(false);
    /*  setErrors({}); */
  };
  const alldayallsotBoolean = async () => {
    // console.log("checkeditem00001 Current", checkeditem);
    // console.log("checkeditem00002 OPP", !checkeditem);
    // console.log("checkeditem00003 Current", menuAvailablityListSaveUpdateDeleteMaster);
    if (checkeditem === true) {
      await setCheckeditem(false);
      await setMenuAvailablityListSaveUpdateDeleteMaster(
        menuAvailablityListSaveUpdateDeleteMaster.map((items) => ({
          ...items,
          slotId: items.slotId.map((object1) => {
            return { ...object1, itemAvailablity: false };
          }),
        }))
      );
    } else if (checkeditem === false) {
      await setCheckeditem(true);
      await setMenuAvailablityListSaveUpdateDeleteMaster(
        menuAvailablityListSaveUpdateDeleteMaster.map((items) => ({
          ...items,
          slotId: items.slotId.map((object1) => {
            return { ...object1, itemAvailablity: true };
          }),
        }))
      );
    }
    // console.log("checkeditem00004 Upd", menuAvailablityListSaveUpdateDeleteMaster);
    // console.log("checkeditem00005 Upd", checkeditem);
  };

  const nestedLevelItemCheck = async (dayId, slotData) => {
    await setMenuAvailablityListSaveUpdateDeleteMaster(
      menuAvailablityListSaveUpdateDeleteMaster.map((items) => ({
        ...items,
        slotId: items.slotId.map((object1) =>
          items.dayId == dayId && object1.slotId == slotData?.slotId
            ? { ...object1, itemAvailablity: !slotData?.itemAvailablity }
            : object1
        ),
      }))
    );
    // console.log("checkeditem0000", menuAvailablityListSaveUpdateDeleteMaster);
  };

  const apiMasterCallOfmenuAvailablityListSaveUpdateDeleteMaster = async () => {
    console.log("current", menuAvailablityListSaveUpdateDeleteMaster);
    console.log("current", menuSubmenuItems);

    // setMenuAvailablityListSaveUpdateDeleteMaster(menuAvailablityListSaveUpdateDeleteMaster =>
    //   menuAvailablityListSaveUpdateDeleteMaster.map(obj => {
    //     obj["mainMenuId"] = menuSubmenuItems?.mainMenuId;
    //     obj["subMenuId"] = menuSubmenuItems?.subMenuId;
    //     obj["menuId"] = menuSubmenuItems?.selectedIndividualFoodItem;
    //     return { ...obj };
    //   }),
    // );

    // let saveupdateMasterOFmenuAvailablityListSaveUpdateDeleteMaster =
    //   menuAvailablityListSaveUpdateDeleteMaster.map(items => ({
    //     ...items,
    //     slotId: items.slotId.filter((item) => item.itemAvailablity === true)
    //       .map((item) => {
    //         return item["slotId"];
    //       })
    //   }));

    // let filtetredsave =
    //   saveupdateMasterOFmenuAvailablityListSaveUpdateDeleteMaster.map(obj => {
    //     obj["mainMenuId"] = menuSubmenuItems?.mainMenuId;
    //     obj["subMenuId"] = menuSubmenuItems?.subMenuId;
    //     obj["menuId"] = menuSubmenuItems?.selectedIndividualFoodItem;
    //     return { ...obj };
    //   });

    // let deleteMasterOFmenuAvailablityListSaveUpdateDeleteMaster =
    //   menuAvailablityListSaveUpdateDeleteMaster.map(items => ({
    //     ...items,
    //     slotId: items.slotId.filter((item) => item.itemAvailablity === false)
    //       .map((item) => {
    //         return item["slotId"];
    //       })
    //   }));

    // let filtetredupdate =
    //   deleteMasterOFmenuAvailablityListSaveUpdateDeleteMaster.map(obj => {
    //     obj["mainMenuId"] = menuSubmenuItems?.mainMenuId;
    //     obj["subMenuId"] = menuSubmenuItems?.subMenuId;
    //     obj["menuId"] = menuSubmenuItems?.selectedIndividualFoodItem;
    //     return { ...obj };
    //   });

    // let savereqformenusubmenu = await saveofMenuAVL(filtetredsave);
    // let deletereqformenusubmenu = await deleteodmenuAVL(filtetredupdate);

    // console.log("finalupdate0001", menuAvailablityListSaveUpdateDeleteMaster);
    // console.log("finalupdate0002", filtetredsave);
    // console.log("finalupdate0003", filtetredupdate);

    swal("Success!", "Time Slots Updated", "success");
    setFoodItemTiming(!foodItemTiming);
  };

  const saveMenuSubmenu = async (key) => {

    let data = "";
    data = {
      outletCode: adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode,
      status: "A",
      menuId: menuSubmenuItems?.mainMenuId,
      menuName: menuSubmenuItems?.menuName || "",
      subMenuId: menuSubmenuItems?.subMenuId || "",
      subMenuName: menuSubmenuItems?.subMenuName || "",
      compCode: adminToMangerCompanyCode || loginDetails?.companyCode,
    };

    let reqformenusubmenu;
    if (key === "Maninmenu") {
      reqformenusubmenu = await saveMainMenuName(data);
    } else if (key === "SubManinmenu") {
      reqformenusubmenu = await saveSubMenuName(data);
    } else {
    }

    if (reqformenusubmenu.data.status === true) {
      setMenuSubmenuItems({});
      setSelectedcategoryMaster({});
      setSelectedsubcategoryMaster({});
      setAddupdatecategory(false);
      setAddupdatesubcategory(false);

      setMainMenuModal(false);
      setSubMenuModal(false);
      setMenuFoodItemModal(false);
      setFoodItemTiming(false);
      getcatsublist(adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode);
      getmainCategoryMaster(adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode);
      getsubcategoryMaster(adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode);

      getMenuMasterListMasterApi();
      // getstaffMasterList();
      // setStaffvalue({});
      // setOutletvalue({});
      setIsview(false);
      setIsedit(false);
      // setLargeModal(!largeModal);

      if (key === "Maninmenu") {
        swal("Success!", "Menu Created", "success");
      } else {
        swal("Success!", "Sub Menu Created", "success");
      }
    } else {
      // await this.setState({ reload: false });
      // NotificationManager.warning("Invalid Data Format");
      // this.setState({ addNewUserModal: true });

      setMainMenuModal(!mainMenuModal);
      getcatsublist(adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode);
      getmainCategoryMaster(adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode);
      getsubcategoryMaster(adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode);
      setSelectedcategoryMaster({});
      setSelectedsubcategoryMaster({});
      getMenuMasterListMasterApi();

      swal("Oops", "Error, Please Try Later", "error");
    }
  };

  const deleteitem = async (key) => {

    console.log("key", key);
    /* console.log("menuSubmenuItems", menuSubmenuItems); */
    let data = "";
    data = {
      outletCode: adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode,
      categoryId: menulistitem.categoryId,
      subCategoryId: menulistitem.subCategoryId,
      itemId: menulistitem.itemId || "",
      compCode: adminToMangerCompanyCode || userDetails?.companyCode,
    };
    let reqformenusubmenu;
    if (key === "Deletemenu") {
      reqformenusubmenu = await deletecategory(data);
    } /* else if (key === "SubManinmenu") {
      reqformenusubmenu = await saveSubMenuName(data);
    }  */ else {
    }

    if (reqformenusubmenu.data.status === true) {
      setMenuSubmenuItems({});
      setDeletepopup(false);
      setAddupdatecategory(false);
      setAddupdatesubcategory(false);

      setMainMenuModal(false);
      setSubMenuModal(false);
      setMenuFoodItemModal(false);
      setFoodItemTiming(false);
      setSelectedcategoryMaster();
      getmenulist(
        outletvalue.value,
        restarantvalue.value
      );
      getMenuMasterListMasterApi();
      // getstaffMasterList();
      // setStaffvalue({});
      // setOutletvalue({});
      setIsview(false);
      setIsedit(false);
      // setLargeModal(!largeModal);

      if (key === "Deletemenu") {
        swal("Success!", "Mapping Deleted", "success");
      } /* else {
        swal("Success!", "Sub Menu Created", "success");
      } */
    } else {
      // await this.setState({ reload: false });
      // NotificationManager.warning("Invalid Data Format");
      // this.setState({ addNewUserModal: true });

      setMainMenuModal(!mainMenuModal);
      getcatsublist(adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode);
      getMenuMasterListMasterApi();

      swal("Oops", "Error, Please Try Later", "error");
      // setIsview(false);
      // setIsedit(false);
      // setLargeModal(!largeModal);
      // getstaffMasterList();
    }
  };

  const UpdateMenuSubmenu = async (key) => {

    console.log("menuSubmenuItems", menuSubmenuItems);
    let data = "";
    data = {
      outletCode: adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode,
      status: "A",
      menuId: menuSubmenuItems?.menuId || "",
      menuName: menuSubmenuItems?.menuName || "",
      subMenuId: menuSubmenuItems?.subMenuId || "",
      subMenuName: menuSubmenuItems?.subMenuName || "",
    };
    let reqformenusubmenu;
    if (key === "Maninmenu") {
      reqformenusubmenu = await UpdateMenuName(data);
    } else if (key === "SubManinmenu") {
      reqformenusubmenu = await UpdateSubMenuName(data);
    } else {
    }

    if (reqformenusubmenu.data.status === true) {
      setMenuSubmenuItems({});
      setAddupdatecategory(false);
      setAddupdatesubcategory(false);

      setMainMenuModal(false);
      setSubMenuModal(false);
      setMenuFoodItemModal(false);
      setFoodItemTiming(false);
      getcatsublist(adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode);

      getMenuMasterListMasterApi();
      // getstaffMasterList();
      // setStaffvalue({});
      // setOutletvalue({});
      setIsview(false);
      setIsedit(false);
      // setLargeModal(!largeModal);

      if (key === "Maninmenu") {
        swal("Success!", "Menu Updated", "success");
      } else {
        swal("Success!", "Sub Menu Updated", "success");
      }
    } else {
      // await this.setState({ reload: false });
      // NotificationManager.warning("Invalid Data Format");
      // this.setState({ addNewUserModal: true });

      setMainMenuModal(!mainMenuModal);
      getcatsublist(adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode);
      getMenuMasterListMasterApi();

      swal("Oops", "Error, Please Try Later", "error");
      // setIsview(false);
      // setIsedit(false);
      // setLargeModal(!largeModal);
      // getstaffMasterList();
    }
  };

  const onChangeCommonpopup = (key, value) => {

    console.log("key", key);
    console.log("value", value);

    let addFieldValue = {};
    let errorsLocal = errors;
    let formIsValidLocal = formIsValid;
    if (key == "categoryName") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["categoryName"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        setSelectedcategoryMaster({ ...value, });
        /*  setSelectedcategoryMaster({
         label: value.label,
         value: value.value,
       }); */
        addFieldValue = { [key]: value };
        errorsLocal["categoryName"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }
    const newFormData = { ...menulistitem };
    newFormData[key] = value;
    setMenulistitem(newFormData);
  };

  const onChangeCommonpopupsetOutletvalue = (key, value) => {
    let addFieldValue = {};
    let errorsLocal = errors;
    let formIsValidLocal = formIsValid;

    const stringPattern = /^[-a-zA-Z-()]+(\s+[-a-zA-Z()]+)*$/;

    //
    //setAdditemSubmenuMaster([]);
    if (key == "menuName") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["menuName"] = "Name is Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!stringPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["menuName"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["menuName"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "subMenuName") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["subMenuName"] = "Name is Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!stringPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["subMenuName"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["subMenuName"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    const newFormData = { ...menuSubmenuItems };
    newFormData[key] = value;
    setMenuSubmenuItems(newFormData);
  };

  /* function getSteps() {
    // return ["Add Item Details", "Variant Item & Add-Ons"];
    return ["Add Item Details"];
  } */

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <FoodMenuForm
            menulistitem={menulistitem}
            additemSubmenuMaster={additemSubmenuMaster}
            /* onChangeCommonpopup={onChangeCommonpopup} */
            category={category}
            errors={errors}
            onChangeCommonpopupsetOutletvalue={
              onChangeCommonpopupsetOutletvalue
            }
          />
        );

      case 1:
        return <VariantItemForm variant={variant} />;

      /* case 2:
        return <AddOnForm typeadd={typeadd} />; */
      /* case 3:
        return <BankDetails />; */
      /*  default:
        return "unknown step"; */
    }
  }

  const chkImgFile = (file) => {
    // console.log("file", file);
    if (file) {
      const fileArr = file.split(".");
      const fileExt = fileArr[fileArr.length - 1];
      if (fileExt.toLowerCase() == "pdf") {
        return false;
      } else {
        return true;
      }
    }
  };
  const skippedSteps = () => {
    return skipped.size;
  };
  const isStepOptional = (step) => {
    return step === 1 || step === 2;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleStep = (step) => {
    console.log("step", step);
    setActiveStep(step);
  };
  /*  const totalSteps = () => {
    return getSteps().length;
  }; */
  const completedSteps = () => {
    return completed.size;
  };

  /* const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps() - skippedSteps();
  }; */

  const submitFoodItemApi = async () => {

    let categoryId = menulistitem?.mainMenuId;
    let compCode = adminToMangerCompanyCode || userDetails?.companyCode;
    let itemId = menulistitem?.menuId;
    let outletCode = adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode;
    let subCategoryId = menulistitem?.subMenuId || "";

    let reqformenusubmenu = await UpdateCategoryItem(
      categoryId,
      compCode,
      itemId,
      outletCode,
      subCategoryId
    );

    if (reqformenusubmenu.data.status === true) {
      swal("Success!", "Item Updated", "success");
      setMenulistitem({});

      setMenuFoodItemModal(false);
      setFoodItemTiming(false);
      setMappingupdate(false);
      getmenulist(
        outletvalue.value,
        restarantvalue.value
      );
      setMainMenuModal(false);
      setSubMenuModal(false);
      setIsview(false);
      setIsedit(false);
    } else {
      swal("Oops", "Error, Please Try Later", "error");
    }
  };

  const setCatSubFromSelectedMenu = async (e) => {

    let outletCode = adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
    let compCode = adminToMangerCompanyCode || loginDetails?.companyCode;
    let getslotList = await MenuList(compCode, outletCode);
    let getslotListValue = getslotList?.data?.data;
    console.log("getslotListValue", getslotListValue);
    let outmaster =
      getslotListValue &&
      getslotListValue.find((value, index) => value?.itemId === e?.value);
    console.log("outmaster123", outmaster);
    console.log("outmaster123", typeof outmaster);

    setSelectedcategoryMaster({
      label: outmaster?.categoryName || "",
      value: outmaster?.categoryId || "",
    });

    setSelectedsubcategoryMaster({
      label: outmaster?.subCategoryName || "",
      value: outmaster?.subCategoryId || "",
    });
  };

  const getMenuAvailalbitList = async () => {
    let outletCode = adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode;
    let mainMenuId = menuSubmenuItems?.menuId;
    let subMenuId = menuSubmenuItems?.subMenuId;
    let menuId = menuSubmenuItems?.selectedIndividualFoodItem;
    let menuavailityList = await getMenuAvailalbitListApi(
      outletCode,
      mainMenuId,
      subMenuId,
      menuId
    );
    // swal("Oops", "Error, Please Try Later", "error");
    await setMenuAvailablityMaster(menuavailityList.data?.data);
    await setMenuSubmenuItems({
      mainMenuId: menuSubmenuItems?.menuId,
      subMenuId: menuSubmenuItems?.subMenuId,
      selectedIndividualFoodItem: menuSubmenuItems?.selectedIndividualFoodItem,
      selectedIndividualFoodItemName:
        menuSubmenuItems?.selectedIndividualFoodItemName,
    });
    // setMenuAvailablityListSaveUpdateDeleteMaster(menuAvailablityListSaveUpdateDeleteMaster =>
    //   menuAvailablityListSaveUpdateDeleteMaster.map(obj => {
    //     obj["slotId"] = enablebollean;
    //     return { ...obj };
    //   }),
    // );
    console.log(
      "menuAvailablityListSaveUpdateDeleteMaster",
      menuAvailablityListSaveUpdateDeleteMaster
    );
    // console.log("menuavailityList", menuavailityList.data?.data);
    console.log("length", menuavailityList.data?.status);

    if (menuavailityList.data?.status === true) {
      /*   */

      setMenuAvailablityListSaveUpdateDeleteMaster(menuavailityList.data?.data);

      // await setMenuAvailablityListSaveUpdateDeleteMaster(menuAvailablityListSaveUpdateDeleteMaster =>
      //   menuAvailablityListSaveUpdateDeleteMaster.map(obj => {
      //     obj["slotId"] = menuavailityList.data?.data;
      //     return { ...obj };
      //   }),
      // );

      // await setMenuAvailablityListSaveUpdateDeleteMaster(
      //   menuAvailablityListSaveUpdateDeleteMaster.map(items => ({
      //     ...items,
      //     slotId: items.slotId && items.slotId.filter(object1 => {
      //       return menuavailityList.data?.data.map(object2 => ({
      //         ...object2,
      //         slotTime: object2.slotTime.some(object3 => {
      //           object1["itemAvailablity"] = true;
      //           object1["itemAvailablity"] = false;
      //           return parseInt(object1.slotId) === parseInt(object3.slotId) ?
      //             { ...object1["itemAvailablity"] = true }
      //             :
      //             { ...object1["itemAvailablity"] = false }
      //         })
      //       }
      //       ));
      //     })
      //   })));
    } else {
      // setMenuAvailablityListSaveUpdateDeleteMaster(
      //   menuAvailablityListSaveUpdateDeleteMaster.map(items => ({
      //     ...items,
      //     slotId: items.slotId.map(object1 => {
      //       return { ...object1, itemAvailablity: true }
      //     })
      //   })));

      await setMenuAvailablityListSaveUpdateDeleteMaster(
        (menuAvailablityListSaveUpdateDeleteMaster) =>
          menuAvailablityListSaveUpdateDeleteMaster.map((obj) => {
            obj["slotId"] = [];
            return { ...obj };
          })
      );
    }

    // setMenuAvailablityListSaveUpdateDeleteMaster(
    //   menuAvailablityListSaveUpdateDeleteMaster.map(items => ({
    //     ...items,
    //     slotId: items.slotId.map((itemss) => {
    //       return itemss.slotId
    //     })
    //       == menuavailityList.data?.data?.map((items2) => {
    //         return items2.slotId
    //       }) ?
    //       // obj["slotId"] = enablebollean;
    //       // return { ...obj };
    //       { ...itemss, itemAvailablity: true }
    //       :
    //       { ...itemss, itemAvailablity: false }
    //   }))
    // );

    console.log(
      "setMenuAvailablityListSaveUpdateDeleteMaster456",
      menuAvailablityListSaveUpdateDeleteMaster
    );
    await setFoodItemTiming(true);
    console.log("vijay", menuSubmenuItems);
  };

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  const onClose = () => {
    setMainMenuModal(!mainMenuModal);
  };

  const CloseImage = () => {
    setOpenImagePopup(!openImagePopup);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const renderItem = ({ item, collapseIcon, handler }) => {
    return (
      <div>
        {handler}
        {collapseIcon}
        {item.mainmenu}
      </div>
    );
  };

  const stylescheck = () => {
    let maxWidth = "";
    if (menuFoodItemModal) {
      return maxWidth == "500px";
    } else if (subMenuModal) {
      return maxWidth == "700px";
    } else {
    }
  };

  let actionOption = {
    name: "actions",
    label: "Actions",
    options: {
      filter: false,
      sort: false,
      customBodyRender: (summary, tableMeta, updateValue) => {
        return (
          <div className="list-action">
            <span
              style={{ color: "white", display: "flex" }}
              className="icon-top-left"
            >
              {/* <button
              type="button"
              className="rct-link-btn edit-btn"
              onClick={() => onEditUser(tableMeta)}
            >
              <i style={{ fontSize: "15px" }} className="ti-pencil"></i>
            </button> */}

<Link
                className=""
                onClick={() => {
                  // setOutletDetails({})
                  itemtoggle(tableMeta);
                }}
              >
                <i
                  className="fas fa-pencil-alt fa-lg tpen-bck"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "1px",
                  }}
                ></i>
              </Link>
              <Link
                className=""
                onClick={() => {
                  // setOutletDetails({})
                  viewtoggle(tableMeta);
                }}
              >
                <i
                  className="ti-eye fa-lg tpen-bck"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "1px",
                  }}
                ></i>
              </Link>

              {/* <Link
                className=""
                onClick={() => {
                  // setOutletDetails({})
                  deletetoggle(tableMeta);
                }}
                // style={{ background: "#008000" }}
              >
                <i
                  className="ti-trash  tpen-bck"
                  style={{ marginLeft: "3px" }}
                ></i>
              </Link>  */}
            </span>

            {/* <span style={{ paddingLeft: "20px",marginTop: "-20px" }} className="icon-top-left">

            <Link className="btn btn-primary shadow btn-xs sharp me-2"
              onClick={() => viewUser(tableMeta)} style={{ background: "#008000" }}
            >
              <i className="fa fa-eye"></i>
            </Link>
          </span> */}
          </div>
        );
      },
    },
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const onChangeRowsPerPage = (numOfRows) => {
    // let { currentPage, itemsPerPage } = this.state;
    setItemsPerPage(numOfRows);
  };
 

  const columns = [
    {
      name: "itemName",
      label: "Item Name",
      options: {
        filter: true,
        sort: true,
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "categoryName",
      label: "Category",
      options: {
        filter: true,
        sort: true,
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
        searchable:true,
      },
    },

    {
      name: "subCategoryName",
      label: "Sub Category ",
      options: {
        filter: true,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },  

    actionOption,
  ];
  const option = {
    filter: true, 
    search: true, 
    selectableRows: false,
    responsive: "stacked",
    fixedHeader: true,
    tableBodyHeight: "60vh",
    fixedSelectColumn: true,
    page: currentPage,
    pagination: true,
    serverSide: false,
    rowsPerPage: itemsPerPage,
    rowsPerPageOptions: [10, 15, 100],
    onChangePage: (newPage) => {
      handleChangePage(newPage);
    },
    onChangeRowsPerPage: (numOfRows) => {
      onChangeRowsPerPage(numOfRows);
    },
    download: false,
    print: false,
    onFilterChange: (column, filterList, type, filterOptions, changedColumnIndex) => {
      
    },
    confirmFilters: true,
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div style={{ marginTop: "40px" }}>
          <Button
            variant="contained"
            onClick={() => applyNewFilters()} 
          >
            Apply Filters
          </Button>
        </div>
      );
    },
    onFilterConfirm: (filterList) => {
      // Handle filter confirmation here if needed
    },
    onFilterDialogOpen: () => {
      // Handle filter dialog open event if needed
    },
    onFilterDialogClose: () => {
      // Handle filter dialog close event if needed
    },
    customToolbar: () => {
      return (
        <>
           
              {/* //   {largeModal ? ( */}
              {/* //     <a */}
              {/* //       href="#"
              //       style={{ backgroundColor: "#008000", color: "white" }}
              //       onClick={(e) => opnAddNewUserModal(e)}
              //       className="caret btn-sm mr-10"
              //     >
              //       ADD <i className="zmdi zmdi-lus"></i>
              //     </a> */}
              {/* //   ) : (
              //     <a */}
              {/* //       href="#"
              //       style={{ */}
              {/* //         backgroundColor: "#008000",
              //         color: "white",
              //         fontSize: "medium",
              //       }}
              //       onClick={(e) => { */}
              {/* //         opnAddNewUserModal(e);
              //         setCustomerDetail({});
              //       }}
              //       className="caret btn-sm mr-10"
              //     >
              //       Add <i className="zmdi zmdi-lus"></i>
              //     </a> */}
              {/*  )} */}
            
        </>
      );
    },
  };
  const themeTable = createMuiTheme({
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: "#FF000",
        },
        paper: {
          boxShadow: "none",
        },
      },
      MuiTableRow: {
        root: {
          "&:nth-of-type(odd)": {
            backgroundColor: "white !important",
          },
          "&:nth-of-type(even)": {
            backgroundColor: "#e4e8ef !important",
          },
        },
      },

      MUIDataTableHeadCell: {
        root: {
          backgroundColor: "#008000 !important",
        },
        data: {
          fontWeight: "bold",
          color: "white",
          fontSize: "14px",
        },
      },
    },
  });
 
  return (
    <>
      {/* 
      <h3 className="card-title">Menu Management -  {selectedOutlet?.label} </h3>
      <br /> */}

      <div className="row">
       { /*  <div className="col-md-4">
          <Card>
            <Card.Header className="card-title">
              Menu List {""}
              <Button
                variant="success dark btn-sm"
                onClick={() => {
                  // setMenuFoodItemModal(false),
                  //  setSubMenuModal(false),
                  setMainMenuModal(true);
                }}
              >
                <i class="fas fa-plus">Menu </i>
              </Button>
              <br />
              <Button
                variant="success dark btn-sm"
                onClick={() => {
                  getMenuMasterListMasterApi();
                  // setMenuFoodItemModal(false),
                  setSubMenuModal(true);
                  // setMainMenuModal(true)
                }}
              >
                <i class="fas fa-plus">Sub-Menu</i>{" "}
              </Button>
            </Card.Header>
            <br />

            <Card.Body>
              <Tab.Container defaultActiveKey="#home">
                <Col lg="6" xl="6">                
                  <ListGroup className="mb-4" id="list-tab">
                    <ListGroup.Item action href="#home">
                      cocount idly
                    </ListGroup.Item>
                    <ListGroup.Item action href="#profile">
                      Paneer Idly
                    </ListGroup.Item>
                    <ListGroup.Item action href="#messages">
                      Masala Dosa
                    </ListGroup.Item>
                    <ListGroup.Item action href="#settings">
                      Ghee Dosa
                    </ListGroup.Item>
                  </ListGroup>
                </Col>
                <Col lg="6" xl="10">
                  <Tab.Content>
                    <Tab.Pane eventKey="#home">
                      <tbody>
                        <tr>
                          <td>Cocount idly</td>
                          <td>30</td>

                          <td>
                            <Badge variant="success light">Veg</Badge>
                          </td>

                          <td>
                            <i
                              onClick={itemtoggle}
                              style={{ fontSize: "large" }}
                              className="ti-pencil"
                            ></i>
                          </td>
                        </tr>
                      </tbody>
                    </Tab.Pane>
                    <Tab.Pane eventKey="#profile">
                      <tr>
                        <td>Paneer Idly</td>
                        <td>60</td>
                        <td>
                          <Badge variant="success light">Veg</Badge>
                        </td>
                        <td>
                          <i
                            onClick={itemtoggle}
                            style={{ fontSize: "large" }}
                            className="ti-pencil"
                          ></i>
                        </td>
                      </tr>
                    </Tab.Pane>
                    <Tab.Pane eventKey="#messages">
                      <tr>
                        <td>Masala Dosa</td>
                        <td>50</td>
                        <td>
                          <Badge variant="success light">Veg</Badge>
                        </td>
                        <td>
                          <i
                            onClick={itemtoggle}
                            style={{ fontSize: "large" }}
                            className="ti-pencil"
                          ></i>
                        </td>
                      </tr>
                    </Tab.Pane>
                    <Tab.Pane eventKey="#settings">
                      <tr>
                        <td>Ghee Dosa</td>
                        <td>90</td>
                        <td>
                          <Badge variant="success light">Veg</Badge>
                        </td>
                        <td>
                          <i
                            onClick={itemtoggle}
                            style={{ fontSize: "large" }}
                            className="ti-pencil"
                          ></i>
                        </td>
                      </tr>
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Tab.Container>
            </Card.Body>

            <br />
          </Card>
        </div> */}

        <div className="col-md-12 col-lg-12 col-sm-12 col-xl-12">
          <Card>
            <div class="row">
             <div class="col-3 col-md-3 col-lg-3">
             <div class="form-group">
                <h3 className="me-auto main-hd">
                  Category Mapping
                </h3>
              </div>
              </div>
              <div class="col-7 col-md-7 col-lg-7 row">
            <Card.Header className="card-title  main-card mn-cds" > 
                  <div class="col-4 col-md-4 col-lg-4 form-group main-frm-grp" style={{ width: "40%",zIndex:"100"}}>
                <label as="a" variant="badge badge-rounded badge-danger">
                  Company
                </label>
                <Select
                  options={companyMaster}
                  value={outletvalue}
                  closeMenuOnSelect={false}
                  search
                  name="stateCode"
                  placeholder="Choose"
                  autoComplete="off"
                  onChange={(event) => {
                    // setMenucategory([]);
                    // setCategoryMaster([]);
                    // subcategoryMaster([]);

                    setSelectedMenuItem({ label: "", value: "", })
                    setSelectedsubcategoryMaster({ label: "", value: "", })
                    setSelectedcategoryMaster({ label: "", value: "", })

                    setMenufetchitem([])
                    setRestarantvalue({ label: "", value: "" })
                    setOutletvalue(event);
                    getoutletMasterList(event?.value);
                  }}
                />
              </div> {"   "}

              <div class="col-4 col-md-4 col-lg-4 form-group main-frm-grp" style={{ width: "32%",zIndex:"800"}}>
                <label as="a" variant="badge badge-rounded badge-danger">
                  Restaurant
                </label>
                <Select
                  options={outletMasterlist}
                  value={restarantvalue}
                  closeMenuOnSelect={false}
                  search
                  name="stateCode"
                  placeholder="Choose"
                  autoComplete="off"
                  onChange={(event) => {
                    // setMenucategory([]);
                    // setCategoryMaster([]);
                    // subcategoryMaster([]);
                    setSelectedMenuItem({ label: "", value: "", })
                    setSelectedsubcategoryMaster({ label: "", value: "", })
                    setSelectedcategoryMaster({ label: "", value: "", })

                    setRestarantvalue(event);
                    getmenulist(outletvalue?.value, event?.value);
                    getmainCategoryMaster(event?.value);
                  }}
                />
              </div>

              {popUpPageShow && (
                <div
                  className="row"
                  style={{
                    position: "absolute",
                    background: "#fff",
                    padding: "10px",
                    width: "900px",
                    left: "-250px",
                    zIndex: 1,
                  }}
                >
                  <div class="col-sm col-md-3 form-group">
                    <label as="a" variant="badge badge-rounded badge-danger">
                      Category
                    </label>
                    <Select
                      options={categoryMaster}
                      search
                      placeholder="Category"
                      value={selectedcategoryMaster}
                      autoComplete="off"
                      // onChange={(e) => { getsubcategoryMaster(e.value) }}
                      onChange={(e) => {
                        setSelectedcategoryMaster(e);
                        /* getsubcategoryMaster(e.value); */
                        const newFormData = { ...menuSubmenuItems };
                        newFormData["mainMenuId"] = e.value;
                        setMenuSubmenuItems(newFormData);
                      }}
                    />
                  </div>

                  <div class="col-sm col-md-3 form-group">
                    <label as="a" variant="badge badge-rounded badge-danger">
                      Sub Category
                    </label>
                    <Select
                      options={subcategoryMaster}
                      search
                      placeholder="SubCategory"
                      autoComplete="off"
                      value={selectedsubcategoryMaster}
                      onChange={(e) => {
                        setSelectedsubcategoryMaster(e);
                        const newFormData = { ...menuSubmenuItems };
                        newFormData["subMenuId"] = e.value;
                        setMenuSubmenuItems(newFormData);
                      }}
                    />
                  </div>
                  <div class="row">
                    <div class="col-sm col-md-12 form-group text-center mt-3">
                      <Button
                        className="me-2"
                        variant="success"
                        onClick={() => {
                          console.log("menulistitem", menulistitem);
                          submitFoodItemApi();
                        }}
                      >
                        Submit
                      </Button>
                      <Button
                        variant="danger light"
                        onClick={() => {
                          setSelectedMenuItem({});
                          setSelectedcategoryMaster({});
                          setSelectedsubcategoryMaster({});
                          setPopUpPageShow(false);
                          onAddUpdateUserModalClose(false);
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </div>
              )}

              <div className="col-md-6 text-right">
                {/* <Button
                    style={{ marginLeft: "700px" }}
                    variant="success dark btn-sm"
                    onClick={() => {
                      setMappinglist(false);
                    }}
                  >
                    Category
                  </Button> */}

                {/* <Button
                   style={{ marginLeft: "700px" }} 
                  variant="success dark btn-sm"
                  onClick={() => {
                    setMenuSubmenuItems({
                      status: "",
                      menuId: "",
                      menuName: "",
                      mainMenuId: "",
                      subMenuId: "",
                      subMenuName: "",
                    });
                    setAddupdatecategory(true);
                    setIsview(false);
                    setIsedit(false);
                  }}
                >
                  Category
                </Button> */}

                {/* <Button
                   style={{ marginLeft: "800px"}} 
                  variant="success dark btn-sm"
                  onClick={() => {
                    setMenuSubmenuItems({
                      status: "",
                      menuId: "",
                      menuName: "",
                      mainMenuId: "",
                      subMenuId: "",
                      subMenuName: "",
                    });
                    setAddupdatesubcategory(true);
                    setIsview(false);
                    setIsedit(false);
                  }}
                >
                  SubCategory
                </Button> */}

                {/* {todaymenuPopup === false ? (
                  <div
                    className="basic-dropdown"
                    style={{ marginLeft: "700px" }}
                  >
                    <Dropdown>
                      <Dropdown.Toggle variant="primary">Menu</Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          href="#"
                          onClick={() => {
                            setTodaymenuPopup(true);
                            setSelectedMenuType("category");
                          }}
                        >
                          Category
                        </Dropdown.Item>

                        <Dropdown.Item
                          href="#"
                          onClick={() => {
                            setTodaymenuPopup(true);
                            setSelectedMenuType("subcategory");
                          }}
                        >
                          Sub Category
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                ) : (
                  <>
                    <div
                      className="basic-dropdown"
                      style={{ marginLeft: "700px" }}
                    >
                      <Dropdown>
                        <Dropdown.Toggle variant="primary">
                          Menu
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            href="#"
                            onClick={() => {
                              setTodaymenuPopup(false);
                              setSelectedMenuType("");
                            }}
                          >
                            Back to Menu
                          </Dropdown.Item>
                          {selectedMenuType == "subcategory" ? (
                            <Dropdown.Item
                              href="#"
                              onClick={() => {
                                setSelectedMenuType("category");
                              }}
                            >
                              Category
                            </Dropdown.Item>
                          ) : (
                            <Dropdown.Item
                              href="#"
                              onClick={() => {
                                setSelectedMenuType("subcategory");
                              }}
                            >
                              Sub Category
                            </Dropdown.Item>
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </>
                )}
                <br /> */}
              </div>

              {/* <Button
                variant="success dark btn-sm"
                style={{ marginLeft: "493px", backgroundColor: "#4cb32b" }}
                onClick={() => {
                  // setMenuFoodItemModal(false),
                  //  setSubMenuModal(false),
                  setMainMenuModal(true);
                }}
              >
                <i class="fas fa-plus">Add Menu </i>
              </Button> */}

              {/* <Button
                variant="success dark btn-sm"
                style={{ backgroundColor: "#4cb32b" }}
                onClick={() => {
                  getMenuMasterListMasterApi();
                  // setMenuFoodItemModal(false),
                  setSubMenuModal(true);
                  // setMainMenuModal(true)
                }}
              >
                <i class="fas fa-plus">Add Sub-Menu</i>{" "}
              </Button> */}

              {/* <Button
                className="me-2"
                variant="success dark btn-sm"
                style={{ backgroundColor: "#4cb32b" }}
                onClick={() => {
                  setMenulistitem({
                    itemDesc: "",
                    itemFoodImage: "",
                    itemId: "",
                    itemName: "",
                    itemPrice: "",
                    itemQuantity: "",
                    itemType: "",
                  });
                  getMenuMasterListMasterApi();
                  setActiveStep(0);
                  setMenuFoodItemModal(true);
                  setIsview(false);
                  setIsedit(false);
                }}
              >
                <i
                  class="fas fa-plus"
                  onClick={() => {
                    setMenulistitem({
                      itemDesc: "",
                      itemFoodImage: "",
                      itemId: "",
                      itemName: "",
                      itemPrice: "",
                      itemQuantity: "",
                      itemType: "",
                    });
                  }}
                >
                  Add Item{" "}
                </i>{" "}
              </Button> */}
            </Card.Header>
            </div>
              </div>
             <Card.Body className="scroll-tbl-fix-header" style={{ padding: "0.875rem" }}>
           
              <div className="row mb-3">
                <div className="col-md-3" style={{zIndex:"800"}}>
                  <label>Menu Item</label>
                  <Select
                    options={menucategory}
                    search
                    placeholder="Search"
                    // autoComplete="off"
                    value={selectedMenuItem}
                    onChange={(e) => {
                      setCatSubFromSelectedMenu(e);
                      setSelectedMenuItem(e);
                      const newFormData = { ...menulistitem };
                      newFormData["menuId"] = e.value;
                      setMenulistitem(newFormData);
                    }}
                  />
                </div>
                <div className="col-md-3" style={{zIndex:"800"}}>
                  <label as="a" variant="badge badge-rounded badge-danger">
                    Category
                  </label>
                  <CreatableSelect
                    options={categoryMaster}
                    className="cat-names-dropdown"
                    search
                    placeholder="Category"
                    value={selectedcategoryMaster}
                    autoComplete="off"
                    // onChange={(e) => { getsubcategoryMaster(e.value) }}
                    onChange={(e) => {
                      setSelectedcategoryMaster(e);
                      getsubcategoryMaster(e.value);
                      const newFormData = { ...menulistitem };
                      newFormData["mainMenuId"] = e.value;
                      setMenulistitem(newFormData);
                    }}
                  />
                  <span className="plus-icon">
                    <i
                      class="fas fa-plus"
                      onClick={() => {
                        setMenuSubmenuItems({
                          status: "",
                          menuId: "",
                          menuName: "",
                          mainMenuId: "",
                          subMenuId: "",
                          subMenuName: "",
                        });
                        setAddupdatecategory(true);
                        setSelectedcategoryMaster({});
                        setSelectedsubcategoryMaster({});
                        setIsview(false);
                        setIsedit(false);
                      }}
                    >
                      {/*  Add Item{" "}  */}
                    </i>
                  </span>
                </div>
                <div className="col-md-3" style={{zIndex:"800"}}>
                  <label as="a" variant="badge badge-rounded badge-danger">
                    Sub Category
                  </label>
                  <Select
                    options={subcategoryMaster}
                    className="cat-names-dropdown"
                    search
                    placeholder="SubCategory"
                    autoComplete="off"
                    value={selectedsubcategoryMaster}
                    onChange={(e) => {
                      setSelectedsubcategoryMaster(e);
                      const newFormData = { ...menulistitem };
                      newFormData["subMenuId"] = e.value;
                      setMenulistitem(newFormData);
                    }}
                  />
                  <span className="plus-icon">
                    <i
                      class="fas fa-plus"
                      onClick={() => {
                        setMenuSubmenuItems({
                          status: "",
                          menuId: "",
                          menuName: "",
                          mainMenuId: "",
                          subMenuId: "",
                          subMenuName: "",
                        });
                        setAddupdatesubcategory(true);
                        setSelectedcategoryMaster({});
                        setSelectedsubcategoryMaster({});
                        setIsview(false);
                        setIsedit(false);
                      }}
                    >
                      {/*  Add Item{" "}  */}
                    </i>
                  </span>
                </div>

                <div className="col-md-3 mt-3">
                  <Button
                    className=" me-2 mt-2"
                    variant="success"
                    style={{ backgroundColor: "green", borderRadius: "2px", border: "0px solid" }}
                    onClick={() => {

                      submitFoodItemApi();
                    }}
                  >
                    Submit
                  </Button>
                  <Button
                    className=" mt-2"
                    variant="danger"
                    style={{ backgroundColor: "#1F3DB6", borderRadius: "2px", border: "0px solid" }}
                    onClick={() => {
                      setSelectedMenuItem({});
                      setSelectedcategoryMaster({});
                      setSelectedsubcategoryMaster({});
                    }}
                  >
                    clear
                  </Button>
                </div>
              </div>
              <div className="tab-hg" style={{height:385}}>
              <RctCollapsibleCard fullBlock>
              <RctCollapsibleCard fullBlock>
                <MuiThemeProvider theme={themeTable}>
                  <MUIDataTable
                    title={""}
                    data={menufetchitem}
                    columns={columns}
                    options={option}
                    columOrder={columns}
                    className={"MuiTabCusCls"}
                  />
                </MuiThemeProvider>
              </RctCollapsibleCard>
            </RctCollapsibleCard>
              {/* <Table responsive >
                <thead>
                  <tr>
                    <th>
                      <strong>ITEM NAME</strong>
                    </th>

                    <th>
                      <strong>CATEGORY</strong>
                    </th>

                    <th>
                      <strong> SUB CATEGORY</strong>
                    </th>
                    {/* <th>
                      <strong>ITEM PRICE</strong>
                    </th> */}

                    {/* <th>
                      <strong>ITEM TYPE</strong>
                    </th> */}

                    {/* <th>
                      <strong>ITEM QTY</strong>
                    </th> */}

                    {/* <th>
                      <strong>IMAGE</strong>
                    </th> */}

                    {/* <th>
                      <strong>ITEM DETAIL</strong>
                    </th> */}

                    {/* <th>
                      <strong>ACTIONS</strong>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {menufetchitem &&
                    menufetchitem.map((items) => {
                      return (
                        <>
                          <tr>
                            <td>{items.itemName}</td>
                            <td>{items.categoryName}</td> */}
                            {/* </div><td>{items.subCategoryName}</td> */}
                            {/* <td>{items.itemPrice}</td> */}
                            {/* <td>
                            <Badge variant="success light">
                              {items.itemType}
                            </Badge>
                          </td> */}
                            {/* <td>{items.itemQuantity}</td> */}
                            {/*  <td>
                            <img
                              src={items.itemFoodImage}
                              onClick={() => {
                                setOpenImagePopup(!openImagePopup);
                                setTempModalPopupValue(
                                  menulistitem?.itemFoodImage
                                );
                              }}
                              width="40%"
                              height="40%"
                              style={{ width: "12px" }}
                              // target="blank"
                            ></img>
                          </td> */}
                            {/* <td>{items.itemDesc}</td> */}
                            {/* <td>
                              <i
                                onClick={() => {
                                  viewtoggle(items);
                                  setViewcategory(true);
                                }}
                                style={{ fontSize: "large" }}
                                className="ti-eye"
                              ></i> */}
                              {/*  <i
                                onClick={() => {
                                  itemtoggle(items);
                                }}
                                style={{
                                  fontSize: "large",
                                  marginLeft: "13px",
                                  marginRight: "13px",
                                }}
                                className="ti-pencil"
                              ></i>  */}

                              {/* {(items.categoryId != null && items.categoryId != "0") &&
                                <i
                                  onClick={() => {
                                    deletetoggle(items);
                                    setDeletepopup(true);
                                  }}
                                  style={{ fontSize: "large", paddingLeft: "15px" }}
                                  className="ti-trash"
                                ></i>}
                            </td>
                          </tr>
                        </>
                      );
                    })}
                </tbody>

                {menufetchitem &&
                  menufetchitem.length <= 0 && (
                    <div style={{ color: "red" }}> No Data Found </div>
                  )}
              </Table> */}
              </div>
            </Card.Body>
          </Card>
        </div>

        {/* <div className="row">
            <div className="col-md-6">
              <h4>Category/Subcategory List</h4>
            </div>
            <div className="col-md-6 text-right">
              <Button
                 style={{ marginLeft: "600px" }} 
                variant="success dark btn-sm"
                onClick={() => {
                  setMappinglist(true);
                }}
              >
                Back
              </Button>

              <Button
                variant="primary"
                 style={{ marginLeft: "600px" }}
                
                onClick={() => {
                  setMenuSubmenuItems({
                    status: "",
                    menuId: "",
                    menuName: "",
                    mainMenuId: "",
                    subMenuId: "",
                    subMenuName: "",
                  });
                  setAddupdatecategory(true);
                  setIsview(false);
                  setIsedit(false);
                }}
              >
                Add Category
              </Button>

              <Button
                variant="primary btn-sm"
                style={{ marginLeft: "600px" }} 

                onClick={() => {
                  setMenuSubmenuItems({
                    status: "",
                    menuId: "",
                    menuName: "",
                    mainMenuId: "",
                    subMenuId: "",
                    subMenuName: "",
                  });
                  setAddupdatesubcategory(true);
                  setIsview(false);
                  setIsedit(false);
                }}
              >
                Add Sub Category
              </Button>
            </div>

            <Col xl="6">
              <div className="col-md-11">
                <Card className="text-white  times-card">
                  <Card.Header>
                    <Card.Title></Card.Title>
                  </Card.Header>
                  <Card.Body className="text-white times-card">
                    <div className="basic-list-group">
                      {categoryitem &&
                        categoryitem.map((items) => {
                          console.log("items", items);
                          return (
                            <ListGroup>
                              <ListGroup.Item
                                action
                                active
                                className="flex-column"
                              >
                                <div className="d-flex w-100 justify-content-between">
                                  <h5 className="mb-3 text-white">
                                    <td>{items.mainMenuName}</td>
                                    <i
                                      onClick={() => {
                                        
                                        setMenuSubmenuItems({
                                          menuName: items?.mainMenuName,
                                          menuId: items?.mainMenuId,
                                        });
                                        setAddupdatecategory(true);
                                        setIsview(true);
                                        setIsedit(false);
                                        setFormIsValid(false);
                                      }}
                                      
                                      style={{
                                        fontSize: "large",
                                        paddingLeft: "350px",
                                      }}
                                      className="ti-pencil"
                                    ></i>
                                  </h5>
                                </div>
                                {items?.subCatList &&
                                  items?.subCatList.map((data) => {
                                    console.log("data", data);
                                    return (
                                      <p className="mb-1">
                                        <td>{data.subMenuName}</td>
                                        <i
                                          onClick={() => {
                                            
                                            setMenuSubmenuItems({
                                              subMenuName: data?.subMenuName,
                                              subMenuId: data?.subMenuId,
                                              menuId: items?.mainMenuId,
                                              menuName: items?.mainMenuName,
                                            });
                                            setAddupdatesubcategory(true);
                                            setIsview(true);
                                            setIsedit(false);
                                            setFormIsValid(false);
                                          }}
                                          
                                          style={{
                                            fontSize: "large",
                                            paddingLeft: "350px",
                                          }}
                                          className="ti-pencil"
                                        ></i>
                                      </p>
                                    );
                                  })}
                              </ListGroup.Item>
                            </ListGroup>
                          );
                        })}
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </Col>
          </div> */}
      </div>

      <Modal
        isOpen={
          mappingupdate ||
          addupdatesubcategory ||
          addupdatecategory ||
          viewcategory ||
          deletepopup
        }
        toggle={() => onAddUpdateUserModalClose()}
        // size={"lg"}
        style={{
          maxWidth:
            (viewcategory && "800px") ||
            (addupdatesubcategory && "500px") ||
            (addupdatecategory && "500px"),
        }}
        backdrop="static"
      >
        <ModalHeader>
          {(mappingupdate &&
            `Update Menu Category (${menulistitem?.itemName})`) ||
            (viewcategory &&
              `View Menu Category - ${menulistitem?.itemName}`) ||
            (deletepopup && " Delete Menu Category") ||
            (addupdatesubcategory && "Sub Category") ||
            (addupdatecategory &&
              (menuSubmenuItems?.status == undefined ||
                menuSubmenuItems?.status == "")
              ? `Category`
              : `Update category`)}
        </ModalHeader>
        <ModalBody>
          {viewcategory && (
            <div className="row">
              <div className="col-sm-6 col-md-4 col-xl-4">
                <FormGroup>
                  <Label for="itemname">
                    Item Name<span class="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="itemname"
                    id="itemname"
                    placeholder="Item Name"
                    maxLength="25"
                    required
                    disabled={isView}
                    autoComplete="off"
                    value={menulistitem?.itemName}
                  />
                  <span style={{ color: "red" }}>{errors["itemName"]}</span>
                </FormGroup>
              </div>
              <div className="col-sm-6 col-md-4 col-xl-4">
                <FormGroup>
                  <Label for="itemprice">
                    Item price<span class="text-danger">*</span>
                  </Label>
                  <Input
                    type="number"
                    name="itemprice"
                    id="itemprice"
                    placeholder="Item price"
                    // maxLength="4"
                    required
                    autoComplete="off"
                    disabled={isView}
                    /*  onChange={(e) => {
              if (e.target.value && e.target.value.length > 4) {
                return false;
              } else {
                onChangeCommonpopupsetOutletvalue("itemPrice", e.target.value)
              };
            }
            } */
                    value={menulistitem?.itemPrice}
                  />
                  <span style={{ color: "red" }}>{errors["itemPrice"]}</span>
                </FormGroup>
              </div>

              <div className="col-sm-6 col-md-4 col-xl-4">
                <FormGroup>
                  <Label for="itemqty">
                    Item Quantity<span class="text-danger">*</span>
                  </Label>
                  <Input
                    type="number"
                    name="itemqty"
                    id="itemqty"
                    placeholder="Item Qty"
                    // maxLength="4"
                    required
                    autoComplete="off"
                    disabled={isView}
                    /* onChange={(e) => {
              if (e.target.value && e.target.value.length > 4) {
                return false;
              } else {
                onChangeCommonpopupsetOutletvalue("itemQuantity", e.target.value)
              };
            }
            } */
                    value={menulistitem?.itemQuantity}
                  />
                  <span style={{ color: "red" }}>{errors["itemQuantity"]}</span>
                </FormGroup>
              </div>

              <div className="col-sm-6 col-md-4 col-xl-4">
                <FormGroup>
                  <Label for="itemfam">
                    Item Tag<span class="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="itemfam"
                    id="itemfam"
                    /* placeholder="Item Qty" */
                    // maxLength="4"
                    required
                    autoComplete="off"
                    disabled={isView}
                    /* onChange={(e) => {
              if (e.target.value && e.target.value.length > 4) {
                return false;
              } else {
                onChangeCommonpopupsetOutletvalue("itemQuantity", e.target.value)
              };
            }
            } */
                    value={menulistitem?.itemTag}
                  />
                  <span style={{ color: "red" }}>{errors["itemTag"]}</span>
                </FormGroup>
              </div>

              <div className="col-sm-6 col-md-4 col-xl-4">
                <Label for="veg">Item Type</Label>
                <FormGroup>
                  <Input
                    type="radio"
                    name="veg"
                    id="veg"
                    checked={menulistitem?.itemType}
                    style={{
                      backgroundColor: menulistitem?.itemType ? "green" : "white",
                    }}
                    onChange={(e) => {
                      onChangeCommonpopup("itemType", true);
                    }}
                  />
                  <Label className="ml-5" for="veg">
                    Veg
                  </Label>
                  <img className="ml-5" src={food9} width="5%" height="5%"></img>{" "}
                  <br />
                  {foodTypeFromOutlet == "veg,nong-veg" && (
                    <>
                      <Input
                        type="radio"
                        name="veg"
                        id="nonveg"
                        checked={!menulistitem?.itemType}
                        style={{
                          backgroundColor: !menulistitem?.itemType
                            ? "green"
                            : "white",
                        }}
                        onChange={(e) => onChangeCommonpopup("itemType", false)}
                      />
                      <Label className="ml-5" for="nonveg">
                        Non-Veg
                      </Label>
                      <img className="ml-5" src={food10} width="5%" height="15%" ></img>
                    </>)}

                </FormGroup>
              </div>

              <div className="col-sm-6 col-md-4 col-xl-4">
                <FormGroup>
                  <Label for="itemfoodimg">
                    Item Food Image<span class="text-danger">*</span>
                  </Label>
                  <br />
                  <img
                    src={menulistitem.itemImagePath}
                    style={{
                      width: "50px",
                      height: "50px",
                      marginLeft: "29px",
                    }}
                  // target="blank"
                  ></img>
                  {/* <Input
                    type="file"
                    onChange={(e) => onChangeCommonpopup("itemFoodImage", e)}
                  /> */}
                </FormGroup>
              </div>

              <div className="col-sm-6 col-md-4 col-xl-4">
                <FormGroup>
                  <Label for="itemqty">
                    Item Description<span class="text-danger">*</span>
                  </Label>
                  <Input
                    type="textarea"
                    name="itemqty"
                    id="itemqty"
                    placeholder="Enter Item description"
                    maxLength="200"
                    required
                    autoComplete="off"
                    disabled={isView}
                    /* onChange={(e) =>
              onChangeCommonpopupsetOutletvalue("itemDesc", e.target.value)
            } */
                    value={menulistitem?.itemDesc}
                  />
                  <span style={{ color: "red" }}>{errors["itemDesc"]}</span>
                </FormGroup>
              </div>

              <div className="col-sm-6 col-md-4 col-xl-4">
                <FormGroup>
                  <Label for="itemqty">
                    Unit of Measure<span class="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="itemqty"
                    id="itemqty"
                    /* placeholder="Enter Uom" */
                    maxLength="200"
                    required
                    autoComplete="off"
                    disabled={isView}
                    /* onChange={(e) =>
              onChangeCommonpopupsetOutletvalue("itemDesc", e.target.value)
            } */
                    value={menulistitem?.uomName}
                  />
                  <span style={{ color: "red" }}>{errors["itemDesc"]}</span>
                </FormGroup>
              </div>

              <div className="col-sm-6 col-md-4 col-xl-4">
                <FormGroup>
                  <Label for="itemqty">
                    Category<span class="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="itemqty"
                    id="itemqty"
                    /* placeholder="Enter Category" */
                    maxLength="200"
                    required
                    autoComplete="off"
                    disabled={isView}
                    /* onChange={(e) =>
              onChangeCommonpopupsetOutletvalue("itemDesc", e.target.value)
            } */
                    value={menulistitem?.categoryName}
                  />
                  <span style={{ color: "red" }}>{errors["itemDesc"]}</span>
                </FormGroup>
              </div>

              <div className="col-sm-6 col-md-4 col-xl-4">
                <FormGroup>
                  <Label for="itemqty">
                    SubCategory<span class="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="itemqty"
                    id="itemqty"
                    /* placeholder="Enter Sub category" */
                    maxLength="200"
                    required
                    autoComplete="off"
                    disabled={isView}
                    /* onChange={(e) =>
              onChangeCommonpopupsetOutletvalue("itemDesc", e.target.value)
            } */
                    value={menulistitem?.subCategoryName}
                  />
                  <span style={{ color: "red" }}>{errors["itemDesc"]}</span>
                </FormGroup>
              </div>
            </div>
          )}
          {deletepopup && (
            <>
              <span>
                Are you sure want to delete category ?{" "}
                <strong>{menulistitem?.itemName}</strong>
              </span>
            </>
          )}
          {mappingupdate && (
            <div className="row">
              <div class="col-sm col-md-6 form-group">
                <label as="a" variant="badge badge-rounded badge-danger">
                  Category
                </label>
                <Select
                  options={categoryMaster}
                  className="cat-names-dropdown"
                  search
                  placeholder="Category"
                  value={selectedcategoryMaster}
                  autoComplete="off"
                  onChange={(e) => {
                    onChangeCommonpopup("categoryName", e);
                    getsubcategoryMaster(e.value);
                    const newFormData = { ...menulistitem };
                    newFormData["mainMenuId"] = e.value;
                    setMenulistitem(newFormData);
                  }}
                />
              </div>
              <div class="col-sm col-md-6 form-group">
                <label as="a" variant="badge badge-rounded badge-danger">
                  Sub Category
                </label>
                <Select
                  options={subcategoryMaster}
                  search
                  placeholder="SubCategory"
                  autoComplete="off"
                  value={selectedsubcategoryMaster}
                  onChange={(e) => {
                    setSelectedsubcategoryMaster(e);
                    const newFormData = { ...menulistitem };
                    newFormData["subMenuId"] = e.value;
                    setMenulistitem(newFormData);
                  }}
                />
              </div>
            </div>
          )}
          {addupdatesubcategory && (
            <div className="row">
              <div class="col-sm col-md-6 form-group">
                <label as="a" variant="badge badge-rounded badge-danger">
                  Category
                </label>
                <Select
                  options={categoryMaster}
                  search
                  placeholder="Category"
                  value={selectedcategoryMaster}
                  autoComplete="off"
                  // onChange={(e) => { getsubcategoryMaster(e.value) }}
                  onChange={(e) => {
                    /* selectedsubcategoryMaster({}); */
                    setSelectedcategoryMaster(e);
                    getsubcategoryMaster(e.value);
                    const newFormData = { ...menuSubmenuItems };
                    newFormData["mainMenuId"] = e.value;
                    setMenuSubmenuItems(newFormData);
                  }}
                />
              </div>
              <div class="col-sm col-md-6 form-group">
                <label as="a" variant="badge badge-rounded badge-danger">
                  Sub Category
                </label>
                <Input
                  type="text"
                  name="subcategory"
                  id="subcategory"
                  placeholder="Enter Subcategory"
                  value={menuSubmenuItems?.subMenuName}
                  maxLength="40"
                  required
                  onChange={(e) => {
                    onChangeCommonpopupsetOutletvalue(
                      "subMenuName",
                      e.target.value
                    );
                  }}
                  //disabled={isView}
                  autoComplete="off"
                />{" "}
              </div>
            </div>
          )}
          {addupdatecategory && (
            <div className="row">
              <div class="col-sm col-md-6 form-group">
                <label as="a" variant="badge badge-rounded badge-danger">
                  Category
                </label>
                <Input
                  type="text"
                  name="category"
                  id="category"
                  placeholder="Enter Category"
                  value={menuSubmenuItems?.menuName}
                  maxLength="40"
                  required
                  onChange={(e) => {

                    console.log("menuSubmenuItems", menuSubmenuItems);
                    onChangeCommonpopupsetOutletvalue(
                      "menuName",
                      e.target.value
                    );
                  }}
                  //disabled={isView}
                  autoComplete="off"
                />{" "}
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          {viewcategory && (
            <Button
              variant="danger"
              onClick={() => {
                setViewcategory(false);
                setErrors({});
                setSelectedcategoryMaster({});
                setSelectedsubcategoryMaster({});
              }}
            >
              Cancel
            </Button>
          )}
          {deletepopup && (
            <>
              <Button
                variant="success"
                onClick={() => {
                  deleteitem("Deletemenu");
                }}
              >
                Delete
              </Button>
              <Button
                variant="danger"
                onClick={() => {
                  setDeletepopup(false);
                }}
              >
                Cancel
              </Button>
            </>
          )}
          {mappingupdate && (
            <>
              <Button
                variant="primary"
                onClick={() => {
                  submitFoodItemApi();
                }}
              >
                Update
              </Button>
              <Button
                variant="secondary"
                onClick={() => {
                  setMappingupdate(false);
                  setErrors({});
                }}
              >
                Cancel
              </Button>
            </>
          )}
          {addupdatesubcategory && (
            <>
              {isView === false && isedit === false && (
                <Button
                  variant="success"
                  onClick={() => {
                    saveMenuSubmenu("SubManinmenu");
                  }}
                >
                  Save
                </Button>
              )}
              {isView === true && isedit === false && (
                <Button
                  variant="success"
                  onClick={() => {
                    UpdateMenuSubmenu("SubManinmenu");
                  }}
                >
                  Update
                </Button>
              )}
              <Button
                variant="danger"
                onClick={() => {
                  setAddupdatesubcategory(false);
                  setErrors({});
                }}
              >
                Cancel
              </Button>
            </>
          )}
          {addupdatecategory && (
            <>
              {isView === false && isedit === false && (
                <Button
                  variant="success"
                  onClick={() => {
                    saveMenuSubmenu("Maninmenu");
                  }}
                >
                  Save
                </Button>
              )}
              {isView === true && isedit === false && (
                <Button
                  variant="primary"
                  onClick={() => {
                    UpdateMenuSubmenu("Maninmenu");
                  }}
                >
                  Update
                </Button>
              )}
              <Button
                variant="danger"
                onClick={() => {
                  setAddupdatecategory(false);
                  setErrors({});
                }}
              >
                Cancel
              </Button>
            </>
          )}
        </ModalFooter>
      </Modal>
    </>
  );
};
export default MenuSubMenuCategory;